module.exports = __webpack_public_path__ + "static/media/25488351_1703510986390752_2131083935556245240_o.0e0343e1.jpg";